import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  ["How long does shipping take?", "Orders are typically dispatched within 1–2 business days. Delivery timelines depend on your location and are shared at checkout and in your tracking page."],
  ["Do you offer free shipping?", "Yes — free shipping on all orders above ₹999. Below that, a small flat shipping fee applies."],
  ["Are IAH products cruelty free?", "Yes. IAH does not test on animals."],
  ["Are your products suitable for sensitive skin?", "Many of our formulations are gentle and suitable for sensitive skin. Please check each product's 'Suitable For' section, and patch test if you have specific sensitivities."],
  ["Where are IAH products made?", "IAH is proudly made in India, inspired by the natural beauty of Meghalaya."],
  ["Can I return a product?", "Yes. Please see our Return & Refund Policy for eligibility and how to raise a return request from your account."],
  ["How do I track my order?", "Visit the Track Order page and enter your order number, or find it under My Account → Orders."],
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-10 py-16 min-h-[60vh]">
      <span className="eyebrow text-moss">Support</span>
      <h1 className="serif text-5xl lg:text-6xl mt-2 mb-12">Frequently Asked</h1>
      <div>
        {FAQS.map(([q, a], i) => (
          <div key={i} className="border-b border-sage/30">
            <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between py-6 text-left" data-testid={`faq-${i}`}>
              <span className="serif text-2xl pr-6">{q}</span>
              <ChevronDown size={20} className={`transition-transform flex-shrink-0 ${open === i ? "rotate-180" : ""}`} />
            </button>
            {open === i && <p className="pb-6 text-forest/70 leading-relaxed">{a}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
